import { render, staticRenderFns } from "./CustomerStatisticsStats.vue?vue&type=template&id=4ab14a19&"
import script from "./CustomerStatisticsStats.vue?vue&type=script&lang=js&"
export * from "./CustomerStatisticsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports